import React from 'react'
import ReactEcharts from "echarts-for-react";
type DataType = {
    value: number;
    name: string;
    color: string;
}
type AppProps = {
    data: DataType[];
    options: any;
    name: string;
    currency: string;
}
const LiabilitiesAndAssetsPieChart = ({ data, options, name, currency }: AppProps) => {
    return (
        <div style={{ width: "100%", height: "300px", border: "1px solid #bfcbe1", borderRadius: "6px", backgroundColor: " #fff", gap: "3%" }}>
            <p className='mt-3 ml-3' style={{ fontWeight: "500", fontSize: "18px", marginBottom: "0px" }}>{name}</p>
            <div className='d-flex' style={{ marginTop: "0px" }}>
                <div style={{ width: "42%" }}>
                    {data?.length && <ReactEcharts
                        option={options}
                        style={{ height: "250px", width: "100%" }}
                        opts={{ renderer: "svg" }}
                    ></ReactEcharts>}
                </div>
                <div className='mt-5' style={{ width: "55%" }}>
                    {data?.map((data: DataType) => {
                        return <div className='d-flex mb-2' style={{ justifyContent: "space-between" }}>
                            <div className='d-flex'>
                                <div style={{ backgroundColor: `${data?.color}`, width: "13px", height: "13px", marginTop: "5px" }}></div>
                                <div className='ml-2' style={{ color: "#262a44" }}>{data?.name}</div>
                            </div>
                            <div style={{ textAlign: "end", fontWeight: "500" }}>{currency}{data?.value}</div>
                        </div>
                    })}
                </div>
            </div>
        </div>
    )
}

export default LiabilitiesAndAssetsPieChart